export enum MemoryStatus {
    Suggested = "Suggested",
    Accepted = "Accepted",
    Rejected = "Rejected",
}
